import dayjs from "dayjs"
import type { Spektrix } from "../../server/lib/spektrix-types"

/** A customer's memberships that haven't expired, soonest expiry first. */
export function currentSubscriptions(subscriptions: readonly Spektrix.CustomerSubscription[] = []) {
  // Spektrix dates are venue-local without an offset, so they're compared as written.
  return subscriptions
    .filter((subscription) => dayjs(subscription.expiryDate).isAfter(dayjs()))
    .sort((a, b) => dayjs(a.expiryDate).valueOf() - dayjs(b.expiryDate).valueOf())
}
